<template>
  <div>
    <div class="main-title">按教练批量优惠</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-input
              placeholder="搜索教练姓名或拼音"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%">
        <el-table-column
          prop="school_name"
          label="驾校名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="累计费用"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="累计优惠"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收合计"
          width="90">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.row)">查看明细</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="discount_left"
          label="剩余可优惠"
          width="120">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showDiscount(scope.row)">点击优惠</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <detail-dialog :user="user" :visible="detailVisible" :params="detailParams" @close="detailVisible = false"></detail-dialog>
    <discount-dialog :visible="discountVisible" :coach="discountCoach" @close="discountVisible = false"></discount-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
import DetailDialog from '../report/DetailDialog'
import DiscountDialog from './DiscountDialog'
export default {
  mixins: [ListFunc, DatePickerOptions],
  components: {
    DetailDialog,
    DiscountDialog
  },
  data () {
    return {
      sqlcode: 'coach_discount_list',
      companyList: [],
      searchForm: {
        query: ''
      },
      detailVisible: false,
      detailParams: {},
      historyVisible: false,
      historyCoachId: 0,
      discountVisible: false,
      discountCoach: {
        coach_id: 0,
        discount_rate: 0
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  methods: {
    showDetail (row) {
      this.detailParams = {
        coach_id: row.coach_id
      }
      this.detailVisible = true
    },
    showHistory (row) {
      this.historyCoachId = row.coach_id
      this.historyVisible = true
    },
    showDiscount (row) {
      this.discountCoach = row
      this.discountVisible = true
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property && column.property.indexOf('discount_left') === 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property && (column.property.indexOf('pay') === 0 || column.property.indexOf('fee') === 0)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'coach_name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/return/Discount.vue